import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {
  mobileMenuOpen = false;
  loanMenuOpen = false;
  aboutMenuOpen = false;
  calculatorMenuOpen = false;

  toggleMobMenu(): void {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  closeMobMenu(): void {
    this.mobileMenuOpen = false;
    this.loanMenuOpen = false;
    this.aboutMenuOpen = false;
    this.calculatorMenuOpen = false;
  }

  toggleLoanMenu(): void {
    this.loanMenuOpen = !this.loanMenuOpen;
    this.aboutMenuOpen = false;
    this.calculatorMenuOpen = false;
  }

  toggleAboutMenu(): void {
    this.aboutMenuOpen = !this.aboutMenuOpen;
    this.loanMenuOpen = false;
    this.calculatorMenuOpen = false;
  }

  toggleCalculatorMenu(): void {
    this.calculatorMenuOpen = !this.calculatorMenuOpen;
    this.loanMenuOpen = false;
    this.aboutMenuOpen = false;
  }
}
